import kamala from '../../kamala'
import Breadcrumb from './Breadcrumb'
import BreadcrumbItem from './BreadcrumbItem'

const KBreadcrumbFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Breadcrumb.name, Breadcrumb)
    Vue.component(BreadcrumbItem.name, BreadcrumbItem)
  },
  KBreadcrumb: Breadcrumb,
  KBreadcrumbItem: BreadcrumbItem,
}

export {
  Breadcrumb,
  BreadcrumbItem,
}

export default KBreadcrumbFamily
